import getMessage from 'src/background/utils/i18n.utils';
import React, { useEffect, useRef, useState } from 'react';
const TOOLTIP_WIDTH = 150;
const TOOLTIP_PADDING = 12;
const TOOLTIP_ARROW_SIZE = 6;
export const CustomTooltip = ({ position, delayShow, message, messageParams, skipTranslation, children, dataTestId, additionalClassName, color, }) => {
    const anchor = useRef(null);
    const tooltip = useRef(null);
    const [isOpen, setOpen] = useState(false);
    const [timeout, setTimeoutId] = useState();
    let [coordinates, setCoordinates] = useState();
    useEffect(() => {
        var _a, _b;
        if (isOpen && (!position || position === 'top')) {
            const divInfo = (_a = anchor.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            const tooltipInfo = (_b = tooltip.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
            if (divInfo && tooltipInfo) {
                setCoordinates({
                    x: divInfo.left + divInfo.width / 2 - TOOLTIP_ARROW_SIZE,
                    y: divInfo.top - tooltipInfo.height - TOOLTIP_ARROW_SIZE - 2,
                });
            }
        }
    }, [isOpen]);
    const show = () => {
        var _a;
        const divInfo = (_a = anchor.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!divInfo)
            return;
        switch (position) {
            case 'left': {
                setCoordinates({
                    x: divInfo.left -
                        TOOLTIP_WIDTH -
                        2 * TOOLTIP_PADDING -
                        TOOLTIP_ARROW_SIZE -
                        2,
                    y: divInfo.top + divInfo.height / 2,
                });
                break;
            }
            case 'right': {
                setCoordinates({
                    x: divInfo.left + divInfo.width + TOOLTIP_ARROW_SIZE + 2,
                    y: divInfo.top + divInfo.height / 2,
                });
                break;
            }
            case 'bottom': {
                setCoordinates({
                    x: divInfo.left + divInfo.width / 2 - TOOLTIP_ARROW_SIZE,
                    y: divInfo.top + divInfo.height + TOOLTIP_ARROW_SIZE,
                });
                break;
            }
            case 'top':
            default: {
                setCoordinates({
                    x: divInfo.left + divInfo.width / 2,
                    y: divInfo.top,
                });
                break;
            }
        }
        let timeoutId = setTimeout(() => {
            setOpen(true);
        }, delayShow ? delayShow : 250);
        setTimeoutId(timeoutId);
    };
    const hide = () => {
        clearTimeout(timeout);
        setTimeout(() => {
            setOpen(false);
        }, 250);
    };
    return (React.createElement("div", { "data-testid": dataTestId, className: `tooltip-container ${additionalClassName}`, onMouseEnter: show, onMouseLeave: hide },
        React.createElement("div", { className: "tooltip-anchor", ref: anchor }, children),
        isOpen && message && coordinates && (React.createElement("div", { ref: tooltip, "data-testid": "tooltip-content", className: `tooltip ${position ? position : 'top'} ${color ? color : ''}`, style: {
                position: 'fixed',
                top: coordinates.y,
                left: coordinates.x,
            }, dangerouslySetInnerHTML: {
                __html: skipTranslation
                    ? message
                    : getMessage(message, messageParams),
            } }))));
};
